import SplitType from 'split-type'

if($('#categories-sequence').length) {

  const text = new SplitType('.category-list h2', { types: 'lines' })



}
